export var AuditLogEnrichmentStatus;
(function (AuditLogEnrichmentStatus) {
    AuditLogEnrichmentStatus["ENRICHMENT_STATUS_UNSPECIFIED"] = "ENRICHMENT_STATUS_UNSPECIFIED";
    AuditLogEnrichmentStatus["ENRICHMENT_STATUS_OK"] = "OK";
    AuditLogEnrichmentStatus["ENRICHMENT_STATUS_FAILED"] = "FAILED";
    AuditLogEnrichmentStatus["ENRICHMENT_STATUS_NOT_APPLICABLE"] = "NOT_APPLICABLE";
})(AuditLogEnrichmentStatus || (AuditLogEnrichmentStatus = {}));
